/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_region = /** @type {(inputs: {}) => string} */ () => {
	return `Region/Stát`
};

const da_region = /** @type {(inputs: {}) => string} */ () => {
	return `Region/stat`
};

const de_region = /** @type {(inputs: {}) => string} */ () => {
	return `Region/Bundesland`
};

const en_region = /** @type {(inputs: {}) => string} */ () => {
	return `Region/State`
};

const es_region = /** @type {(inputs: {}) => string} */ () => {
	return `Región/Estado`
};

const fr_region = /** @type {(inputs: {}) => string} */ () => {
	return `Région/État`
};

const hu_region = /** @type {(inputs: {}) => string} */ () => {
	return `Régió/Állam`
};

const it_region = /** @type {(inputs: {}) => string} */ () => {
	return `Regione/Stato`
};

const nl_region = /** @type {(inputs: {}) => string} */ () => {
	return `Regio/Staat`
};

const pl_region = /** @type {(inputs: {}) => string} */ () => {
	return `Region/województwo`
};

const pt_region = /** @type {(inputs: {}) => string} */ () => {
	return `Região/Estado`
};

const sv_region = /** @type {(inputs: {}) => string} */ () => {
	return `Region/Stat`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const region = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.region(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("region", locale)
	if (locale === "cs") return cs_region(inputs)
	if (locale === "da") return da_region(inputs)
	if (locale === "de") return de_region(inputs)
	if (locale === "en") return en_region(inputs)
	if (locale === "es") return es_region(inputs)
	if (locale === "fr") return fr_region(inputs)
	if (locale === "hu") return hu_region(inputs)
	if (locale === "it") return it_region(inputs)
	if (locale === "nl") return nl_region(inputs)
	if (locale === "pl") return pl_region(inputs)
	if (locale === "pt") return pt_region(inputs)
	return sv_region(inputs)
};